import { EMonth } from "@/types/common/month.ts";

const globalLocale = {
  common: {
    yes: "Oui",
    no: "Non",
    filters: {
      hide: "Masquer les filtres",
      display: "Afficher les filtres",
    },
  },
  global: {
    surface: "Surface",
    postalAddress: "Adresse postale",
    geolocalizedAddress: "Adresse géolocalisée",
    all: "Tous",
    clearAll: "Tout retirer",
    welcomeName: "Bienvenue {name} 👋",
    companyName: "Nom de l'entreprise",
    externId: "Identifiant externe",
    beforeNumber: "Avant {number}",
    refreshResults: "Actualiser",
    optional: "Optionnel",
    serial: "Numéro de série",
    hwId: "Hardware Id",
    csId: "CS Id",
    installationDate: "Date d'installation",
    enabled: "Actif",
    disabled: "Inactif",
    hello: "Bonjour",
    site: "Site",
    sites: "Sites",
    details: "Détails",
    results: "Résultats",
    category: "Catégorie",
    operator: "Opérateur",
    previous: "Précédent",
    next: "Suivant",
    priority: "Priorité",
    noResults: "Aucun résultat",
    noResultsDesc: "Aucun résultat n'a été remonté",
    creationDate: "Date de création",
    description: "Description",
    expandAll: "Tout développer",
    collapseAll: "Tout réduire",
    dae: "Actions / Événements",
    filterEventCategories: "Filtrer les types d'événements",
    password: "Mot de passe",
    comment: "Commentaire",
    submit: "Valider",
    status: "Status",
    cancel: "Annuler",
    modulator: "Modulateur",
    modulators: "Modulateurs",
    planning: "Planning MyV",
    device: "Appareil",
    eligibleDevices: "Appareil éligibles",
    radiators: "Radiateurs",
    waterHeaters: "Chauffe-eau",
    pac: "PAC",
    devicesAlreadyInstalled: "Appareils déjà équipés",
    devicesLeftToInstalll: "Appareils restants à équiper",
    eligible: "Éligible",
    leftToInstall: "Restants à installer",
    alreadyInstalled: "Déjà installés",
    devices: "Appareils",
    add: "Ajouter",
    mombox: "Module de communication",
    momboxs: "Modules de communication",
    temperatureSensor: "Capteur de température",
    temperatureSensors: "Capteurs de température",
    sensor: "Capteur",
    sensors: "Capteurs",
    partnership: "Partenariat",
    consent: "Consentement",
    subscription: "Abonnement",
    ok: "Ok",
    nok: "NOK",
    update: "Mettre à jour",
    analyze: "Analyser",
    partner: "Partenaire",
    deliveryPoint: "Point de livraison",
    search: "Rechercher",
    upload: "Upload",
    subscriber: "Adhérent",
    subscriberId: "Id Adhérent",
    mission: "Mission",
    missions: "Missions",
    operation: "Opération",
    operations: "Opérations",
    id: "Identifiant",
    address: "Adresse",
    subscribedPower: "Puissance souscrite",
    firstname: "Prénom",
    lastname: "Nom",
    fullname: "Nom",
    email: "Email",
    phone: "Numéro de téléphone",
    psb: "Saint Bernard",
    vip: "VIP",
    zipCode: "Code postal",
    city: "Ville",
    country: "Pays",
    pilot: "Pilote",
    pilotCsId: "Pilote CS ID",
    pilotHwId: "Pilote HW ID",
    modCsId: "Modulateur CS ID",
    modHwId: "Modulateur HW ID",
    modNeuronId: "Modulateur Neuron ID",
    modSerialNumber: "Modulateur Serial",
    asc: "Ascendant",
    desc: "Descendant",
    error: "Une erreur est survenue, merci de réessayer ultérieurement",
    formError: "Une erreur empeche de continuer, merci de vérifier les champs",
    missingInfo: "Information manquante",
    truncatedTitle: "Affichage partiel",
    truncated: "Trop de données à afficher",
    months: {
      [EMonth.JANUARY]: "Janvier",
      [EMonth.FEBRUARY]: "Février",
      [EMonth.MARCH]: "Mars",
      [EMonth.APRIL]: "Avril",
      [EMonth.MAY]: "Mai",
      [EMonth.JUNE]: "Juin",
      [EMonth.JULY]: "Juillet",
      [EMonth.AUGUST]: "Août",
      [EMonth.SEPTEMBER]: "Septembre",
      [EMonth.OCTOBER]: "Octobre",
      [EMonth.NOVEMBER]: "Novembre",
      [EMonth.DECEMBER]: "Décembre",
    },
    offer: "Offres",
    appliances: "Équipements",
    appointments: "Rendez-vous",
  },
};

export type GlobalLocale = typeof globalLocale;
export default globalLocale;
